import React from "react";
import { Navigate } from "react-router-dom";
import NemontoLandingPage from "./nemonto-landing-page";

const AuthLandingEntry = () => {
  const authToken = localStorage.getItem("uzoneAuthToken");
  if (authToken) {
    return <Navigate to="/pages/home" replace />;
  }
  return <NemontoLandingPage />;
};

export default AuthLandingEntry;
